import codePulse from 'codepulse-web';

const env =
  window.location.host === 'motor.cathay-ins.com.cn' ? 'prod' : 'test';
codePulse.Init({ projectName: 'we-mobile-web-car', env });
